var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtLayoutHeaderFooter',{staticClass:"hub-saude-layout",attrs:{"bg":"#F6F6F9","header":{ titleLabel: 'Hub de saúde', variant: 'navy', backRoute: _vm.headerBackRoute },"footer":true}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }